<div class="inline-png-checkbox text-center">
    <p-checkbox [(ngModel)]="activo" [binary]="true" [disabled]="true"></p-checkbox>
</div>
